import { CustomDialog } from '../../../../components/CustomDialog';
import { useState } from 'react';
import {
  AutoCompleteController,
  Button,
  InputController,
} from '../../../../components';
import {
  useAppDispatch,
  useAppSelector,
} from '../../../../storeHook';
import { showAlert } from '../../../../services/alert';
import {
  useCancelOrderMutation,
  useCancelOrderV2Mutation,
} from '../../../../services/orders';
import * as yup from 'yup';
import { useFormWithSchema } from '../../../../utils/functions/yupFormTypescript';
import { TButtonVariant } from '../../../../types';
import { INITIATED_BY_OPTIONS } from '../orderItems/hepler';
import {
  TOrder,
  TRetailerSalesOrderLineItem,
} from '../../../../utils/types/orders';
import './index.scss';

const REASON_OPTIONS_WITH_UGDN = [
  {
    label: 'Ordered by mistake',
    value: 'Ordered by mistake',
  },
  {
    label: 'Found better price outside',
    value: 'Found better price outside',
  },
  {
    label: 'No longer needed',
    value: 'No longer needed',
  },
  {
    label: 'Delayed invoicing',
    value: 'Delayed invoicing',
  },
  {
    label: 'Stock unavailability',
    value: 'Stock unavailability',
  },
  {
    label: 'Other',
    value: 'Other',
  },
];

const REASON_OPTIONS_WITHOUT_UGDN = [
  {
    label: 'Stock unavailability',
    value: 'Stock unavailability',
  },
  {
    label: 'Incorrect price',
    value: 'Incorrect price',
  },
  {
    label: 'Other',
    value: 'Other',
  },
];

const formSchema = yup.object({
  reason: yup.string().required('please select reason'),
  otherReason: yup
    .string()
    .when('reason', ([reason], schema) => {
      return reason == 'Other'
        ? schema.required('please enter reason here')
        : schema;
    }),
  initiator: yup
    .string()
    .required('please select initiator'),
});
type TFormData = yup.InferType<typeof formSchema>;

export const CancelOrderBtnAndPopUp: React.FC<{
  orderDetails: TOrder;
  lineItemDetails?: TRetailerSalesOrderLineItem;
}> = ({ orderDetails, lineItemDetails }) => {
  const {
    formState: { errors },
    handleSubmit,
    control,
    watch,
    register,
  } = useFormWithSchema(formSchema, {
    mode: 'onTouched',
  });

  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false);
  const [orderAction] = orderDetails.partCancelReturnAllowed
    ? useCancelOrderMutation()
    : useCancelOrderV2Mutation();
  const isUGDNPresent = useAppSelector(
    (state) => state.authUser.ugdn
  );

  let type = 'ORDER_FULL';
  let noteText =
    'Note : On clicking <strong>‘Cancel order’</strong>, amount for cancelled no of cartons will be refunded to the retailer.';
  let btnText = 'Cancel Entire Order';
  let buttonVeriant: TButtonVariant = 'button--secondary';

  if (lineItemDetails) {
    type = 'LINE_ITEM_FULL';
    noteText = '';
    btnText = 'Cancel Full';
    buttonVeriant = 'button--quaternary';
  }

  const onSubmit = (formData: TFormData) => {
    setOpen(false);
    orderAction({
      reason:
        formData.reason === 'Other'
          ? formData.otherReason || ''
          : formData.reason,
      initiator: formData.initiator,
      type,
      retailerSalesOrderId: orderDetails.id,
      ...(lineItemDetails
        ? {
            lineItemId: lineItemDetails.id,
            qty: lineItemDetails.originalTargetQuantity,
          }
        : {}),
    })
      .unwrap()
      .then((res) => {
        dispatch(
          showAlert({
            content: res.message,
          })
        );
      })
      .catch((err) => {
        console.log('error', err);
        // this.utility.handleError(err);
      });
  };

  const product = lineItemDetails?.product;
  const popUpTitle =
    (product?.productName
      ? `${product?.productName} - ${product.unitMeins}`
      : product?.maktx) || 'Cancel Entire Order';

  return (
    <>
      <Button
        onClick={() => setOpen(!open)}
        className="ml-2"
        variant={buttonVeriant}>
        {btnText}
      </Button>
      <CustomDialog
        isForm
        dialogTitle={popUpTitle ? popUpTitle : btnText}
        open={open}
        setOpen={setOpen}
        onSubmit={handleSubmit(onSubmit)}
        actionText={{
          submit: 'Cancel Order',
          cancel: 'Cancel',
        }}
        maxWidth="sm"
        noteEle={
          noteText ? (
            <div className="note-container py-2 px-3">
              {noteText}
            </div>
          ) : undefined
        }>
        <div className="my-10 grid grid-cols-2 gap-10">
          <AutoCompleteController
            label="Cancel Reason"
            control={control}
            name="reason"
            options={
              isUGDNPresent
                ? REASON_OPTIONS_WITH_UGDN
                : REASON_OPTIONS_WITHOUT_UGDN
            }
            error={errors.reason?.message}
            required
          />
          <AutoCompleteController
            label="Initiated by"
            control={control}
            name="initiator"
            options={INITIATED_BY_OPTIONS}
            error={errors.initiator?.message}
            required
          />
          {watch('reason') === 'Other' && (
            <InputController
              label="Enter reason"
              register={register('otherReason')}
              error={errors.otherReason?.message}
              required
            />
          )}
        </div>
      </CustomDialog>
    </>
  );
};
